import { arrayOf, bool, func, number, shape, string } from 'prop-types'
import { Component } from 'react'

import { withI18n } from 'shared/utils/withI18n'
import Slider from 'views/components/atoms/Slider'
import StarRating from 'views/components/molecules/StarRating'

import './StarRatingSlider.scss'

class StarRatingSlider extends Component {
  static MIN = 0
  static MAX = 5

  static propTypes = {
    name: string.isRequired,
    delimiterLabel: string,
    values: arrayOf(number),
    snap: bool,
    onValuesUpdated: func,
    onSliderDragEnd: func,
    onStarClick: func,
    i18n: shape({}),
  }

  static defaultProps = {
    delimiterLabel: null,
    values: [StarRatingSlider.MIN, StarRatingSlider.MAX],
    snap: true,
    onValuesUpdated: null,
    onSliderDragEnd: null,
    onStarClick: null,
  }

  onStarClick = (value, isMin) => {
    const { onStarClick } = this.props

    if (onStarClick) {
      onStarClick(value, isMin)
    }

    return null
  }

  onFromStarsClick = value => {
    this.onStarClick(value, true)
  }

  onToStarsClick = value => {
    this.onStarClick(value, false)
  }

  render() {
    const {
      name,
      delimiterLabel,
      onValuesUpdated,
      onSliderDragEnd,
      values: [min, max],
      i18n,
    } = this.props

    return (
      <div className="m-StarRatingSlider">
        <div className="l-flex l-flex--distribute-space u-margin-x-large--bottom m-StarRatingSlider__from-to__wrapper">
          <div className="a-box a-box--bordered a-box--x-small">
            <StarRating
              rating={min}
              iconSize="x-small"
              alignToEnd
              onClick={this.onFromStarsClick}
              hasSuperScript={false}
            />
          </div>
          {delimiterLabel && (
            <div className="m-StarRatingSlider__from-to__delimiter-label">
              {delimiterLabel}
            </div>
          )}
          <div className="a-box a-box--bordered a-box--x-small">
            <StarRating
              rating={max}
              iconSize="x-small"
              alignToEnd
              onClick={this.onToStarsClick}
            />
          </div>
        </div>
        <div className="u-padding--left u-padding--right">
          <Slider
            id={name}
            max={StarRatingSlider.MAX}
            min={StarRatingSlider.MIN}
            aria-valuemin={StarRatingSlider.MIN}
            aria-valuemax={StarRatingSlider.MAX}
            aria-label={i18n._('filter.input-range.slider.aria')}
            onChange={(event, values) => onValuesUpdated({ values })}
            onChangeCommitted={onSliderDragEnd}
            step={1}
            value={[min, max]}
          />
        </div>
      </div>
    )
  }
}

export default withI18n()(StarRatingSlider)
